module.exports = __webpack_public_path__ + "images/services/confluence-mark-gradient-blue.f72423d57e94de083cdb.svg";